module.exports = __webpack_public_path__ + "img/aroma-benefit-quality.6fa3eb73.svg";